import React, { useState } from "react";

// services
import { Mixpanel, MixpanelEvents } from "../services/Mixpanel";

// seo
import Seo from "../components/Seo";

// constants
import constant from "../constants";

// utils
import { getSessionId } from "../utils";

// custom hooks
import { useCommonPageTracking } from "../hooks/usePageTracking";

// bannerImg
import bannerImg from "../images/aboutProgram/banner.png";

// styles
import * as styles from "./index.module.css";

// components
import Banner from "../components/Banner";
import FiveCards from "../components/Cards/FiveCards/FiveCards";
import HealthyMetabolismComponent from "../components/AboutProgram/HealthyMetabolism/HealthyMetabolism";
import AiTwinWorkComponent from "../components/AboutProgram/AiTwinWork/AiTwinWork";
import MeetAiTwinComponent from "../components/AboutProgram/MeetAiTwin/MeetAiTwin";
import MemberJourneyComponent from "../components/AboutProgram/MemberJourney/MemberJourney";
import HealthRecoveryComponent from "../components/AboutProgram/HealthRecovery/HealthRecovery";
import SuccessStoriesV3 from "../components/Home/SuccessStories/SuccessStoriesV3";
import FaqComponent from "../components/Home/Faq/Faq";

const AboutProgramPage = props => {
  const [sessionId, setSessionId] = useState(getSessionId());

  // Use common page tracking hooks
  const { deviceType, operatingSystem } = useCommonPageTracking(
    "About Program Page",
    props.location.search
  );

  const updateSessionId = () => {
    setSessionId(getSessionId());
  };

  // Mixpanel Events -> Cta Click events
  const handleMixpanelCTA = (ctaText, ctaLocation) => {
    Mixpanel.track(MixpanelEvents.contact_button_clicked, {
      page_name: "About Program Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      cta_text: ctaText,
      cta_location: ctaLocation,
      device_type: deviceType,
      operating_system: operatingSystem,
    });
  };

  // Mixpanel Events -> FAQ Click Events
  const handleMixpanelCTAFaq = (faqText, faqDesc) => {
    Mixpanel.track(MixpanelEvents.faq_clicked, {
      page_name: "About Program Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      faq_text: faqText,
      faq_desc: faqDesc,
      faq_location: "About Program Page - FAQ Clicked",
      device_type: deviceType,
      operating_system: operatingSystem,
    });
  };

  return (
    <>
      <Seo
        title="When Metabolism Is Healthy, You Feel It | Twin Health"
        description="See how Twin's AI Digital Twin heals your metabolism at the root, helping you reverse diabetes, obesity, PMOS and BP and reclaim your energy for life."
      />
      <Banner
        pageName="About Program"
        title="When your metabolism is healthy, you feel it"
        description="Twin helps you discover a personalised metabolic health program for better lifelong care. Improve lifestyle conditions like diabetes, overweight, PMOS, fatty liver, high blood pressure, high cholesterol and other long-term metabolic issues."
        bannerImage={bannerImg}
        imageWidth="614px"
        imageHeight="566px"
        ctaText="Get Started"
        ctaLink="/wbdt-care-plan/#wbdt-form"
        onCtaClick={() =>
          handleMixpanelCTA(
            "Get Started",
            "About Program Page - Banner Section"
          )
        }
      />

      <div className={styles.aboutProgramPage__cards}>
        <FiveCards cards={constant.ABOUT_PROGRAM_PAGE_CARDS} />
      </div>

      <HealthyMetabolismComponent
        ctaText="Start Your Journey"
        ctaVariant="primary"
        redirectionLink="/wbdt-care-plan/#wbdt-form"
        onCtaClick={ctaText => {
          handleMixpanelCTA(
            ctaText,
            "About Program Page - Healthy Metabolism Section"
          );
        }}
      />

      <AiTwinWorkComponent
        ctaText="Play Video"
        sessionId={sessionId}
        updateSessionId={updateSessionId}
        videoName="About Program Page - How Ai Digital Twin Works"
        videoLink="https://www.youtube.com/embed/Ez0gwD5WZRE"
        onCtaClick={ctaText => {
          handleMixpanelCTA(
            ctaText,
            "About Program Page - How AI Digital Twin Works Section"
          );
        }}
        videoPageName="About Program Page"
      />

      <MeetAiTwinComponent />

      <MemberJourneyComponent />

      <HealthRecoveryComponent />

      <SuccessStoriesV3
        title="Check out our Success Stories"
        subTitle=""
        videoData={constant.SUCCESS_STORIES_VIDEOS}
        handleMixpanelCTA={handleMixpanelCTA}
        sessionId={sessionId}
        updateSessionId={updateSessionId}
        video_name="About Program Page - Success Stories Video"
      />

      <FaqComponent
        title="Frequently Asked Questions"
        accordionPayload={constant.ABOUT_PROGRAM_FAQ}
        onCtaClick={(faqText, faqDesc) =>
          handleMixpanelCTAFaq(faqText, faqDesc)
        }
      />
    </>
  );
};

export default AboutProgramPage;
